import { RefObject, useRef, useState } from 'react';

import { useClickOutside } from '../../../hooks';
import { useTheme } from '../../../providers/Provider';
import { Form, Spacing } from '../../../theme';
import { Dropdown, DropdownOptionProps } from '../../Dropdown';
import { Icon } from '../../Icon';
import { StyledDropdownButton, StyledPostTabContainer } from './InputAddonsAfter.style';

export interface InputAddonsAfterProps {
  dropdownOptions: Array<DropdownOptionProps>;
  onSelect: (value: string) => void;
}

export function InputAddonsAfter({ dropdownOptions, onSelect }: InputAddonsAfterProps) {
  const [isOpened, setIsOpened] = useState<boolean>(false);
  const [dimensions, setDimensions] = useState({
    top: 0,
    left: 0,
    width: Form.SelectSize.XSmall,
  });
  const labelRef = useRef<HTMLButtonElement>(null);
  const handleClickOutside = () => setIsOpened(false);
  const containerRef = useClickOutside(handleClickOutside);
  const theme = useTheme();
  const toggleVisibility = (visible?: boolean) => {
    const isVisible = visible ?? !isOpened;

    setIsOpened(visible ?? !isOpened);

    if (isVisible && labelRef.current) {
      const boundingClientRect = labelRef.current.getBoundingClientRect();

      setDimensions({
        top: boundingClientRect.top,
        left: boundingClientRect.left + boundingClientRect.width + Spacing.Size.XXSmall,
        width: Form.SelectSize.XSmall,
      });
    }
  };
  const handleSelect = (selectedValue: string) => {
    toggleVisibility(false);
    onSelect?.(selectedValue);
  };

  return (
    <StyledPostTabContainer ref={containerRef as RefObject<HTMLDivElement>}>
      <StyledDropdownButton ref={labelRef} onClick={() => toggleVisibility()}>
        <Icon name={'chevron---right'} color={theme.Color.Neutrals.Dark} />
      </StyledDropdownButton>
      <Dropdown
        options={dropdownOptions}
        dimensions={dimensions}
        opened={isOpened}
        onSelect={handleSelect}
      />
    </StyledPostTabContainer>
  );
}
